import React, {  forwardRef, useState } from "react";
import Css from "./NavBar.module.css";
import { Link } from "react-router-dom";
import { CiHome } from "react-icons/ci";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { GiSkills } from "react-icons/gi";
import { IoCodeWorking } from "react-icons/io5";
import Menu from "./Menu/Menu";
import { LiaCertificateSolid } from "react-icons/lia";
const NavBar  = forwardRef (({waring},about) => {
  const [setScroll, getScroll] = useState(false);
  const scrollx = () => {
    if (window.scrollY >= 344) {
      getScroll(true);
    } else {
      getScroll(false);
    }
  };
  window.addEventListener("scroll", scrollx);
  
  return (
    <div>
      <div className={Css.parent}>
        <div className={`${Css.boxHeader}  ${setScroll ? Css.bg : Css.hide}`}>
          <div className={`${Css.container}`}>
            <h1>Portfolio</h1>
            <Menu />
          </div>
        </div>
      </div>
      <div className={Css.twoParent}>
        <nav>
          <ul>
            <li ><Link onClick={() => window.scrollTo(0, 0)}><CiHome /></Link></li>
            <li><Link onClick={()=>about.current?.scrollIntoView({behavior : "smooth"})}> <IoIosInformationCircleOutline /></Link></li>
            <li><a href="#works"><IoCodeWorking /></a></li>
            <li><a href="#certificate"><LiaCertificateSolid  /></a></li>
            <li><Link onClick={()=>window.scrollTo(0,100000)}><GiSkills /></Link></li>
          </ul>
        </nav>
      </div>
    </div>
  );
});

export default NavBar;
